import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useMiddlewareChangelogQuery } from '@entities/changelog'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => {
  const kidId = to.params.id

  if (typeof kidId !== 'string' || !kidId) return

  useMiddlewareChangelogQuery(to, {
    route: 'admin.kid.changelog',
    params: { kid_id: kidId },
  })
})
